import React from 'react';

function format(number, n, x) {
  const re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
  return number.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
}

export default function (number, sale = 0) {
  return <>{format((number * (1 - sale)))}&thinsp;₴</>;
}
